import { HOME_FAQ, HOME_H1 } from "./homeContent";
import {
  SITE_NAME,
  buildCanonicalUrl,
  getSiteUrl,
} from "@/lib/siteSeo";

export {
  SITE_NAME,
  buildCanonicalUrl,
  getSiteUrl,
} from "@/lib/siteSeo";

export const SEO_TITLE =
  "Meu Barbeiro PRO | Sistema para Barbearia e Agenda Online";

export const SEO_DESCRIPTION =
  "Gerencie sua barbearia com agenda online, clientes, equipe e serviços em um só lugar. Conheça o Meu Barbeiro PRO e organize seus atendimentos.";

export const SEO_PRIMARY_TOPIC = "sistema para barbearia";

export const SEO_SECONDARY_TOPICS = [
  "software para barbearia",
  "agenda online para barbearia",
  "gestão de barbearia",
  "agendamento online para barbeiro",
];

export function buildOrganizationJsonLd(siteUrl: string) {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: SITE_NAME,
    url: siteUrl,
    logo: `${siteUrl}/images/logo.png`,
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "customer support",
      email: "suporte@meubarbeiropro.com",
      availableLanguage: ["Portuguese"],
    },
    sameAs: [
      "https://www.instagram.com/meubarbeiropro_?utm_source=ig_web_button_share_sheet&igsi=ZDNlZDc0MzIxNw==",
    ],
  };
}

export function buildSoftwareApplicationJsonLd(siteUrl: string) {
  return {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: SITE_NAME,
    applicationCategory: "BusinessApplication",
    operatingSystem: "Web",
    url: siteUrl,
    description: SEO_DESCRIPTION,
    offers: {
      "@type": "Offer",
      priceCurrency: "BRL",
      url: `${siteUrl}/register`,
      description:
        "Teste grátis de 7 dias; planos pagos a partir de R$ 29,90/mês",
    },
  };
}

export function buildWebSiteJsonLd(siteUrl: string) {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: SITE_NAME,
    url: siteUrl,
  };
}

export function buildFaqPageJsonLd() {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: HOME_FAQ.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer,
      },
    })),
  };
}

export function buildHomeJsonLd(siteUrl: string) {
  return [
    buildOrganizationJsonLd(siteUrl),
    buildSoftwareApplicationJsonLd(siteUrl),
    buildWebSiteJsonLd(siteUrl),
    buildFaqPageJsonLd(),
  ];
}

export function assertHomeSeoContract() {
  return {
    h1: HOME_H1,
    title: SEO_TITLE,
    description: SEO_DESCRIPTION,
    canonical: buildCanonicalUrl("/"),
    hasPrimaryTopic: HOME_H1.toLowerCase().includes(SEO_PRIMARY_TOPIC),
  };
}
